import React, { Fragment } from 'react';
import { COLORS } from 'Components/utils/color/colors';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { getKeyValue, t } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Icon } from 'Components/frameworks/icon/Icon';
import { SeeMore } from 'Components/frameworks/see-more/SeeMore';
type Props = {
  items: ReadonlyArray<{
    iconName: string;
    label: string;
  }>;
};
export const ReassuranceBlock = ({ items }: Props) => {
  const { isTablet } = useResponsive();
  const track = useTracking({
    actionGA: 'calendarPrice',
    labelGA: 'reinsuranceTravel_readMore',
    siteSection: 'Shopping_Resort',
  });
  const reinsuranceLinkURL = getKeyValue('booking.form.reinsuranceLinkURL');
  const reinsuranceLegalMentions = t('booking.form.reinsuranceLegalMentions')?.trim();
  const TagName = isTablet ? Fragment : SeeMore;
  const seeMoreProps = isTablet
    ? null
    : {
        classNameButton: 'text-end',
        color: COLORS.LIGHT_SAND,
        hasNoScrollOnCollapse: true,
        isCollapseEnabled: !isTablet,
        seeLessLabel: t('common.loadLess'),
        seeMoreLabel: t('common.loadMore'),
        seeMoreSize: 110,
      };
  return (
    <aside className="space-y-15 rounded-12 border-1 border-lightGrey p-15 font-sans text-14 text-black">
      <header>
        <h4 className="text-16 font-bold">{t('booking.form.reinsuranceTitle')}</h4>
        <p className="font-bold">{t('booking.form.reinsuranceSubtitle')}</p>
      </header>

      <TagName {...seeMoreProps}>
        {!!items.length && (
          <ul className="space-y-10">
            {items.map(({ iconName, label }) => (
              <li className="flex items-center gap-5" key={iconName}>
                <Icon className="shrink-0" name={iconName} width="1.25rem" />
                {label}
              </li>
            ))}
          </ul>
        )}

        {!!reinsuranceLinkURL && (
          <DynamicLink
            className="mt-15 inline-block underline hocus:text-black-active md:mt-0"
            onClick={() => track()}
            target="_blank"
            url={reinsuranceLinkURL}
          >
            {t('booking.form.reinsuranceLinkLabel')}
          </DynamicLink>
        )}

        {!!reinsuranceLegalMentions && <p className="mt-15 md:mt-0">{reinsuranceLegalMentions}</p>}
      </TagName>
    </aside>
  );
};
